module.exports = __webpack_public_path__ + "static/media/alchemist-wings-1.6fac47c0.glb";